import {
    IconButton,
    Tooltip,
    CircularProgress,
} from "@mui/material";

const actionColors = {
    delete: {
        color: "#DC2626",
        border: "#FECACA",
        bg: "#FEF2F2",
        hoverBorder: "#FCA5A5",
    },

    info: {
        color: "#2563EB",
        border: "#DBEAFE",
        bg: "#EFF6FF",
        hoverBorder: "#93C5FD",
    },

    view: {
        color: "#7C3AED",
        border: "#E9D5FF",
        bg: "#F5F3FF",
        hoverBorder: "#C4B5FD",
    },

    warning: {
        color: "#D97706",
        border: "#FDE68A",
        bg: "#FFFBEB",
        hoverBorder: "#FCD34D",
    },

    success: {
        color: "#059669",
        border: "#D1FAE5",
        bg: "#F0FDF4",
        hoverBorder: "#6EE7B7",
    },
};

const CustomIconButton = ({
    type = "info",
    icon,
    tooltip = "",
    onClick,
    size = 34,
    disabled = false,
    loading = false,
}) => {

    const palette =
        actionColors[type] || actionColors.info;

    const isDisabled = disabled || loading;

    return (
        <Tooltip
            title={loading ? "Loading..." : tooltip}
        >
            <span>
                <IconButton
                    size="small"
                    disabled={isDisabled}
                    onClick={onClick}
                    sx={{
                        width: size,
                        height: size,

                        border: `1px solid ${palette.border}`,
                        borderRadius: "8px",

                        color: palette.color,

                        transition: "all .2s ease",

                        "&:hover": !isDisabled
                            ? {
                                backgroundColor: palette.bg,
                                borderColor: palette.hoverBorder,
                                transform: "translateY(-1px)",
                            }
                            : {},

                        "&.Mui-disabled": {
                            opacity: 0.7,
                            borderColor: palette.border,
                        },
                    }}
                >
                    {loading ? (
                        <CircularProgress
                            size={16}
                            thickness={5}
                            sx={{
                                color: palette.color,
                            }}
                        />
                    ) : (
                        icon
                    )}
                </IconButton>
            </span>
        </Tooltip>
    );
}

export default CustomIconButton;